import { useEffect, useState } from 'react'

import { practitionerFormsState$, readPractitionerFormsState } from '../practitioner-forms-state'
import { PractitionerFormsState } from '../utils'

export type UsePractitionerFormsState = PractitionerFormsState | undefined

const isPractitionerFormsStateEqual: (
  a: PractitionerFormsState | undefined,
  b: PractitionerFormsState | undefined,
) => boolean = (a, b) =>
  a && b ? a.lastEvent === b.lastEvent && a.notifyAfter === b.notifyAfter : !a && !b

export const usePractitionerFormsState: () => UsePractitionerFormsState = () => {
  const [practitionerFormsState, setLocalPractitionerFormsState] = useState(
    // initialize state from local storage
    readPractitionerFormsState,
  )

  // subscribe to storage events
  useEffect(() => {
    const subscription = practitionerFormsState$.subscribe((newValue) =>
      setLocalPractitionerFormsState((prevState) =>
        isPractitionerFormsStateEqual(prevState, newValue) ? prevState : newValue,
      ),
    )
    return () => subscription.unsubscribe()
  }, [])

  return practitionerFormsState
}
